'use client'
import React, { useState } from 'react'
import Link from 'next/link'

export default function LoginFormPopup() {
  const [lineLoading, setLineLoading] = useState(false)

  // LINE 登入：先跟後端拿授權連結，再導頁到 LINE
  const handleLineLogin = async () => {
    if (lineLoading) return
    setLineLoading(true)
    try {
      const storeNumber = process.env.NEXT_PUBLIC_STORE_NUMBER || 1
      const res = await fetch(
        `/api/lineLogin/GetLineLoginUrl?StoreNumber=${storeNumber}`,
        { cache: 'no-store', headers: { Accept: 'application/json' } }
      )
      const data = await res.json().catch(() => ({}))
      const loginUrl = data?.Data?.LoginUrl
      if (data?.Error || !loginUrl) {
        alert(data?.Error || '無法取得 LINE 登入連結')
        return
      }
      window.location.href = loginUrl
    } catch (e) {
      alert(`LINE 登入失敗：${e?.message || e}`)
    } finally {
      setLineLoading(false)
    }
  }

  return (
    <div
      className="aside aside_right overflow-hidden customer-forms"
      id="customerForms"
    >
      <div className="customer-forms__wrapper d-flex position-relative">
        <div className="customer__login">
          <div className="aside-header d-flex align-items-center">
            <h3 className="text-uppercase fs-6 mb-0">登入</h3>
            <button className="btn-close-lg js-close-aside ms-auto"></button>
          </div>
          {/* <!-- /.aside-header --> */}

          <form onSubmit={(e) => e.preventDefault()} className="aside-content">
            <div className="form-floating mb-3">
              <input
                name="email"
                type="email"
                className="form-control form-control_gray"
                placeholder="name@example.com"
              />
              <label>帳號 *</label>
            </div>

            <div className="pb-3"></div>

            <div className="form-label-fixed mb-3">
              <label className="form-label">密碼 *</label>
              <input
                name="password"
                className="form-control form-control_gray"
                type="password"
                placeholder="********"
              />
            </div>

            <div className="d-flex align-items-center mb-3 pb-2">
              <div className="form-check mb-0">
                <input
                  name="remember"
                  className="form-check-input form-check-input_fill"
                  type="checkbox"
                  defaultValue=""
                />
                <label className="form-check-label text-secondary">
                  記住我
                </label>
              </div>
              <Link href="/reset_password" className="btn-text ms-auto">
                忘記密碼?
              </Link>
            </div>

            <button
              className="btn btn-primary w-100 text-uppercase"
              type="submit"
            >
              登入
            </button>

            <div className="text-center my-3 text-secondary">或</div>

            <button
              type="button"
              onClick={handleLineLogin}
              disabled={lineLoading}
              className="btn w-100 d-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: '#06C755',
                color: '#fff',
                fontWeight: 700,
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M12 2C6.48 2 2 5.64 2 10.13c0 4.02 3.55 7.39 8.35 8.03.32.07.77.21.88.49.1.25.06.65.03.9l-.14.85c-.04.25-.2.98.86.53s5.71-3.36 7.79-5.76C21.29 13.48 22 11.9 22 10.13 22 5.64 17.52 2 12 2z" />
              </svg>
              {lineLoading ? '前往 LINE 登入…' : '使用 LINE 登入'}
            </button>

            <div className="customer-option mt-4 text-center">
              <span className="text-secondary">還不是會員?</span>
              <Link
                href="/LoginOrRegister#register-tab"
                className="btn-text js-show-register"
              >
                註冊
              </Link>
            </div>
          </form>
        </div>
        {/* <!-- /.customer__login --> */}

        <div className="customer__register">
          <div className="aside-header d-flex align-items-center">
            <h3 className="text-uppercase fs-6 mb-0">建立會員</h3>
            <button className="btn-close-lg js-close-aside btn-close-aside ms-auto"></button>
          </div>
          {/* <!-- /.aside-header --> */}

          <form onSubmit={(e) => e.preventDefault()} className="aside-content">
            <div className="form-floating mb-4">
              <input
                name="username"
                type="text"
                className="form-control form-control_gray"
                placeholder="Username"
              />
              <label>登入帳號</label>
            </div>

            <div className="pb-1"></div>

            <div className="form-floating mb-4">
              <input
                name="email"
                type="email"
                className="form-control form-control_gray"
                placeholder="user@company.com"
              />
              <label>Email address *</label>
            </div>

            <div className="pb-1"></div>

            <div className="form-label-fixed mb-4">
              <label className="form-label">密碼 *</label>
              <input
                name="password"
                className="form-control form-control_gray"
                type="password"
                placeholder="*******"
              />
            </div>

            <p className="text-secondary mb-4">
              Your personal data will be used to support your experience
              throughout this website, to manage access to your account, and for
              other purposes described in our privacy policy.
            </p>

            <button
              className="btn btn-primary w-100 text-uppercase"
              type="submit"
            >
              Register
            </button>

            <div className="customer-option mt-4 text-center">
              <span className="text-secondary">Already have account?</span>
              <a href="#" className="btn-text js-show-login">
                Login
              </a>
            </div>
          </form>
        </div>
        {/* <!-- /.customer__register --> */}
      </div>
      {/* <!-- /.customer-forms__wrapper --> */}
    </div>
  )
}
